module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
fox.registerTemplate("popup_communityname", [["div",{"class":"guiLargePopupContent message-popup"},[["div",{"class":"label","data-fox-alias":"1","data-fox-context":"popup_communityname"},[["textNode",{"text":"Please choose your ModelCentro Community nickname"}]]],["div",{},[["input",{"style":"width:100%;","class":"mc-form-field","required":"","id":"input-communityName","name":"communityName","type":"text","data-fox-alias":"2","placeholder":"Add your nickname","data-fox-context":"popup_communityname"}]]]]]]);
 /* fox-dynamic-injection */ 
};


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/node_modules/fox-dynamic-injection!/var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/node_modules/fox-template-loader?interpolate!/var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/admin/common/frame/templates/popup/communityName.tpl
// module id = 254
// module chunks = 2